module.exports = __webpack_public_path__ + "img/lifelinequeensland.8d89f64.png";